import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DxLookupComponent,
  DxTextBoxComponent,
  DxTextAreaComponent,
  DxDateBoxComponent,
  DxNumberBoxComponent,
  DxDataGridComponent,
  DxButtonComponent,
  DxPopupComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
  DxTemplateDirective,
  DxLoadPanelComponent,
} from 'devextreme-angular';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { alert, confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { Dipendente } from 'src/app/models/dipendente';
import { MovimentoArticoloModel } from 'src/app/models/movimento-articolo';
import { Parametri } from 'src/app/models/parametri';
import { ProposteGestione } from 'src/app/models/proposte-gestione';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliConsegnatiComponent } from 'src/app/shared/components/articoli/articoli-consegnati/articoli-consegnati.component';
import { ArticoliPrevistiByDipendenteComponent } from 'src/app/shared/components/dipendenti/articoli-previsti-by-dipendente/articoli-previsti-by-dipendente.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { ProposteGestioneService } from 'src/app/shared/services/proposte-gestione.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { KitArticoliService } from 'src/app/shared/services/kit-articoli.service';

@Component({
  selector: 'app-nuova-consegna',
  templateUrl: './nuova-consegna.component.html',
  styleUrls: ['./nuova-consegna.component.scss'],
  imports: [
    DxLookupComponent,
    DxTextBoxComponent,
    DxTextAreaComponent,
    DxDateBoxComponent,
    DxNumberBoxComponent,
    DxDataGridComponent,
    DxTextAreaComponent,
    DxButtonComponent,
    DxPopupComponent,
    DxValidationGroupComponent,
    DxValidatorComponent,
    ArticoliPrevistiByDipendenteComponent,
    ArticoliConsegnatiComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoEditingComponent,
    DxTemplateDirective,
    DxoLookupComponent,
    DxiButtonComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoTextsComponent,
    DxLoadPanelComponent,
  ],
  standalone: true,
})
export class NuovaConsegnaComponent
  extends GestArticoliBaseComponent
  implements OnInit {
  private route = inject(ActivatedRoute);
  private navService = inject(NavigatorService);
  private dipS = inject(DipendentiService);
  private parametriS = inject(ParametriService);
  private articoliS = inject(ArticoliService);
  private catArticoliS = inject(CategorieArticoliService);
  private tipiArticoliS = inject(TipiArticoliService);
  private proposteService = inject(ProposteGestioneService);
  private articoliMatService = inject(ArticoliMatricolaService);
  private movS = inject(MovimentoArticoliService);
  private alertS = inject(AlertService);
  private kitArticoliService = inject(KitArticoliService);
  @ViewChild('gridDettaglioMov', { static: false })
  gridDettaglioMov!: DxDataGridComponent;
  @ViewChild('gridMatricoleDaConsegnare', { static: false })
  gridMatricoleDaConsegnare!: DxDataGridComponent;
  @ViewChild('gridMatricoleRitiro', { static: false })
  gridMatricoleRitiro!: DxDataGridComponent;

  nuovoMovimento: MovimentoArticoloModel = new MovimentoArticoloModel();

  listDip: Dipendente[] = []; //Lista dipendenti
  listCatArticoli: CategorieArticoli[] = [];
  listTipiArticoli: TipiArticoli[] = [];
  listTipiArticoliFiltrati: TipiArticoli[] = []; // Lista Tipi articoli filtrati per categia selezionata
  listArticoliFiltro: Articoli[] = [];
  listProposteConsegna: ProposteGestione[] = [];
  articoliList: Articoli[] = [];
  dettParametro: Parametri = new Parametri();

  idCatArticolo?: number;
  idDipendente?: number;
  idMansioneRif?: number;
  idArticoloRif?: number;
  idDipendenteRif?: number;

  controllaSottoscorta: any;
  gestMatricole: boolean;
  consentiSalvataggio = false;
  nErrorQta: number;

  msgErrorDettaglioMov?: string;

  changes: Change<DettaglioMovimento>[] = [];

  dataMovimento?: Date;

  popUpVisiblePrevisti: boolean = false;
  popUpVisibleConsegne: boolean = false;
  popUpVisibleGeneraMatricole: boolean = false;

  articoloRif?: number;
  abilitaGestioneMatricole: boolean = false; //Se articolo prevede la gestione delle matricole attivo card per gestione amtricole consegna e restituzione
  isCambio: boolean = false; //Se articolo inserito è un cambio
  abilitaButtonInsertProdotti: boolean = false; //abilita/disabilitabutton insert nuovi articoli da consegne effettuate e previste

  //Assegnazione matricole
  listMatricoleDisponibili?: any[];
  listMatricoleDisponibiliFiltrate?: any[];
  idArticoloMatricolaDaAssegnare: number | null = null;
  listDettaglioRif?: DettaglioMovimento;
  numMaxDaconsegnare: number = 0;
  //  numConsegnati: number = 0;

  listPropsArtNewMatricola?: any[];
  dataScadenzaMatricole?: Date;
  matricolaNew?: string;
  newArticoloMatricola?: ArticoliMatricola;

  listMatricoleAssegnateDipendente?: any[];
  listMatricoleAssegnateDipendenteFiltrate?: any[];
  numMaxDaritirare: number = 0;
  numRitirati: number = 0;
  idArticoloMatricolaAssegnato: number | null = null;

  popupKit: boolean = false;
  idArticoloKit?: number;
  visibleLoadPanel: boolean = false;
  listArticoliMatricole?: ArticoliMatricola[];

  inInserimento: boolean = false;

  listDettaglioBS = new BehaviorSubject<DettaglioMovimento[]>([]);


  constructor() {
    super();
    this.gestMatricole = this.isModVisible('Matricole');
    this.consentiSalvataggio = false;
    this.nErrorQta = 0;
    this.hasEditingDetail = this.hasEditingDetail.bind(this);
    this.getFilteredArticoli = this.getFilteredArticoli.bind(this);
    this.eliminaArticolo = this.eliminaArticolo.bind(this); //Grid
    this.eliminaMatricolaArticolo = this.eliminaMatricolaArticolo.bind(this); // Grid matricole assegnate
    this.eliminaMatricolaArticoloRitiro =
      this.eliminaMatricolaArticoloRitiro.bind(this); // Grid matricole assegnate
    this.initControllaSottoscortaFunction();
  }

  ngOnInit() {
    this.loadLookups();

    this.nuovoMovimento = new MovimentoArticoloModel();
    this.nuovoMovimento.listDettaglio = [];
    this.dataMovimento = new Date();
    this.nuovoMovimento.firmato = false;
    this.idDipendente = 0;

    const idDipendenteParam = this.route.snapshot.paramMap.get('idDipendente');
    if (idDipendenteParam != null && idDipendenteParam != '0') {
      this.nuovoMovimento.idDipendente = +idDipendenteParam;
      this.idDipendente = +idDipendenteParam;
      this.abilitaButtonInsertProdotti =
        this.idDipendente != undefined && this.idDipendente > 0;

      this.loadProposteDipendente();

      const dipSel = this.listDip.filter((x) => x.id == this.idDipendente);
      this.idMansioneRif = dipSel[0].idMansione;
    }
    this.listDettaglioBS.subscribe(list => {
      this.nuovoMovimento.listDettaglio = [...list];
      if (list.length > 0) {
        this.controllaSottoScortaFunc();
      } else {
        this.consentiSalvataggio = false;
      }
    });
  }

  loadLookups() {
    console.log("load lookups");
    //Parametro sottoscorta
    this.parametriS.get('verifica-sottoscorta').subscribe({
      next: (dati) => {
        this.dettParametro = dati;
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento parametro sottoscorta', 'error', 3000);
        }
      },
    });

    //List Dipendenti
    this.dipS.listTemp().subscribe({
      next: (dati) => {
        this.listDip = dati
          .filter((x) => x.attivo == true)
          .sort(function (a, b) {
            return a.nominativo < b.nominativo ? -1 : 1;
          });
      }
    });

    //Lista Matricole Articoli
    this.articoliMatService.list().subscribe({
      next: (res) => {
        this.listArticoliMatricole = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero matricole articoli', 'error');
        }
      },
    });

    this.articoliS.listTemp().subscribe({
      next: (res) => {
        //console.log("caricata lista articoli");
        this.articoliList = res;
        this.checkLoadData();
      }
    });
    this.tipiArticoliS.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        //console.log("caricata lista tipi articoli");
        this.listTipiArticoli = res;
        this.checkLoadData();
      }
    });
    this.catArticoliS.listTemp().subscribe({
      next: (res) => {
        //console.log("caricata lista cartegorie");
        this.listCatArticoli = res.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
        this.checkLoadData();
      }
    });

  }

  checkLoadData() {
    //console.log("art len: " + this.articoliList?.length);
    //console.log("tipi len: " + this.listTipiArticoli?.length);
    //console.log("cat len: " + this.listCatArticoli?.length);

    if (this.listTipiArticoli?.length > 0 && this.articoliList?.length > 0 && this.listCatArticoli?.length > 0) {
      //console.log("eseguo check load data");  
      this.listTipiArticoli = this.listTipiArticoli.filter((t) =>
        this.listCatArticoli.find((c) => c.id == t.idCategoria)
      );
      //console.log("tipi len puliti: " + this.listTipiArticoli.length);
      this.articoliList = this.articoliList
        .filter((a) => this.listTipiArticoli.find((t) => t.id == a.idTipo))
        .sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1));
      //console.log("art len puliti: " + this.articoliList.length);
      this.idCatArticolo = this.listCatArticoli[0].id;
      this.loadTipiArticoliFiltrati();
      this.loadListArticoliFiltro();
    }
  }

  loadListArticoliFiltro() {
    this.listArticoliFiltro = this.articoliList
      .filter((a) =>
        this.listTipiArticoli.find(
          (t) => t.idCategoria == this.idCatArticolo && t.id == a.idTipo && a.attivo,
        ),
      )
      .sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1));
  }

  loadProposteDipendente() {
    this.listProposteConsegna = [];
    this.proposteService
      .search({
        idDipendente: this.idDipendente,
        tipoProposta: 'C',
      })
      .subscribe({
        next: (res) => {
          this.listProposteConsegna = res;
        },
        error: (error) => {
          console.error('Errore caricamento proposte P: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento proposte consegna', 'warning');
          }
        },
      });
  }

  catArticoloSelected(data: any) {
    this.idCatArticolo = data.value;
    this.loadTipiArticoliFiltrati();
    this.loadListArticoliFiltro();

    // console.log('Categoria sel:' + this.idCatArticolo);
  }

  loadTipiArticoliFiltrati() {
    this.listTipiArticoliFiltrati = this.listTipiArticoli
      .filter((x) => (x.idCategoria == this.idCatArticolo))
      .sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1));
  }

  getFilteredArticoli(options: any) {
    const ret = {
      store: this.listArticoliFiltro,
      filter: options.data
        ? ['idTipo', '=', options.data.idTipoArticolo]
        : null,
    };
    return ret;
  }

  //LOOKUP
  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }
    return (
      item.codice +
      (item.taglia ? ' - ' + item.taglia : '') +
      ' - ' +
      item.descrizione
    );
  }

  //FORM

  salvaMovimento(e: any) {
    const result = e.validationGroup.validate('form-nuova-consegna');
    if (!result.isValid) {
      return; // blocca il salvataggio
    }

    // Controllo gestione matricole
    if (!this.validaListaArticoli(this.nuovoMovimento.listDettaglio)) {
      notificaMessaggio('Gestione matricole incompleta.', 'warning');
      return; // blocca il salvataggio
    }

    this.nuovoMovimento.data = moment(this.dataMovimento).utc(true).toDate();
    /*if (this.changes != null) {
      // Salvo i gli articoli caricati
      this.gridDettaglioMov.instance.saveEditData();
    }*/

    //Controllo se ho inserito almento un articolo
    this.msgErrorDettaglioMov = '';
    if (this.nuovoMovimento.listDettaglio.length == 0) {
      this.msgErrorDettaglioMov = 'Assegnare un articolo';
      return;
    }

    if (this.nuovoMovimento.listDettaglio.length > 0) {
      console.log('valori:' + JSON.stringify(this.nuovoMovimento));

      //Data
      const data = new Date(this.nuovoMovimento.data);
      const realDay = data.getDate();
      const realMonth = data.getMonth();
      const realYear = data.getFullYear();
      this.nuovoMovimento.data = new Date(
        Date.UTC(realYear, realMonth, realDay),
      );
      this.visibleLoadPanel = true;
      this.movS.insert(this.nuovoMovimento).subscribe({
        next: (dati) => {
          //console.log('ricevuto:' + dati);
          
          this.visibleLoadPanel = false;
          if (dati.result) {
            if (dati.errori != null && dati.errori.length > 0) {
              this.mostraAlertResult(
                dati.errori,
                'Movimento inserito con avvisi:',
              );
            } else {
              notify({
                message: 'Movimento inserito',
                width: 300,
                shading: true,
              });
            }
            this.navService.goToDocMovimento(dati.newMovimento.progr);
            this.movS.updateCurrentListMovimentiArticoli();
            //Gestione alert
            this.alertS.sendClickEvent();
          } else {
            if (dati.errori != null && dati.errori.length > 0) {
              this.mostraAlertResult(dati.errori, 'Movimento non inserito');
            }
            notify('Errore inserimento movimento', 'warning', 1000);
          }
        },
        error: (error) => {
          
          this.visibleLoadPanel = false;
          console.error('Errore insert movimento: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore salvataggio nuovo movimento', 'warning');
          }
        },
        
      });
    }
  }

  validaListaArticoli(lista: DettaglioMovimento[]): boolean {
    return lista.every((item) => {
      //Controllo che tutt gli elementi dell'array soddisifino la condizione
      if (item.usaMatricola) {
        return item.matricoleConvalidate === true;
      }
      return true; // se non usa matricola è automaticamente valido
    });
  }

  mostraAlertResult(errori: string[], title: string) {
    let strErroriHtml = '<ul>';
    errori.forEach((element) => {
      strErroriHtml += '<li>' + element + '</li>';
    });
    strErroriHtml += '</ul>';
    alert(strErroriHtml, title);
  }

  dipendenteSelected(e: any) {
    //console.log("Dip. selezionato: " + data.value)
    this.abilitaButtonInsertProdotti = e.value && e.value > 0; //Gestione abilitazione button insert articoli
    this.gridDettaglioMov.instance.repaint();

    this.idDipendente = e.value;
    this.loadProposteDipendente();

    const dipSel = this.listDip.filter((x) => x.id == e.value);
    this.idMansioneRif = dipSel[0].idMansione;
  }

  //GRID
  get changesText(): string {
    return JSON.stringify(
      this.changes.map((change) => ({
        type: change.type,
        key: change.type !== 'insert' ? change.key : undefined,
        data: change.data,
      })),
      null,
      ' ',
    );
  }

  onInitNewRow(e: any) {
    this.inInserimento = true;
    this.abilitaGestioneMatricole = false;
    e.data.cambio = this.storeS.paramLoginCorrente.cambioConsegna;
    e.data.listDettaglio = [];
    this.disattivaGestioneMatricole.bind(this);
    this.gridDettaglioMov.instance.refresh();
    this.gridDettaglioMov.instance.repaint();
  }

  onEditorPreparing(e: any) {
    if (e.dataField === 'idTipoArticolo' || e.dataField === 'idArticolo') {
      // disabilita l'editor se non è una nuova riga
      if (!e.row?.isNewRow) {
        e.editorOptions.readOnly = true;
      }
    }
  }

  disattivaGestioneMatricole() {
    this.abilitaGestioneMatricole = false;
  }

  onRowInserting(e: any) {
    const newRow = e.data;

    // Controllo  se esiste già la stessa chiave
    const exists = this.nuovoMovimento.listDettaglio.some(
      (item) => item.idArticolo === newRow.idArticolo,
    );

    if (exists) {
      notificaMessaggio('Questo articolo è già presente ', 'error');
      // Blocco l'inserimento
      e.cancel = true;
    }
    const art = this.listArticoliFiltro.find((x) => x.id == newRow.idArticolo);
    if (art!.gestioneKit) {
      this.idArticoloKit = art!.id;
      this.popupKit = true;
    }
  }

  onRowInserted(e: any) {
    //Assegno il focus alla nuova riga inserta
    this.inInserimento = false;
    const key = e.key;
    setTimeout(() => {
      this.gridDettaglioMov.instance.option('focusedRowKey', key);
    }, 100);
    this.controllaSottoScortaFunc();
  }

  onFocusedRowChanged(e: any) {
    const rowData = e.row && e.row.data;

    if (rowData) {
      if (rowData.idDipendente) {
        this.idDipendenteRif = rowData.idDipendente;
      }

      if (rowData.idArticolo) {
        this.idArticoloRif = rowData.idArticolo;
        // notificaMessaggio("Articolo selezionato: " + this.idArticoloRif, "success");
        this.isCambio = rowData.cambio;

        this.abilitaGestioneMatricole = rowData.usaMatricola; // se il tipo articolo prevede la gestione delle matricole attivo le card per la gestione delle matricole in consegna e restituzione
        this.numMaxDaconsegnare = rowData.qta; // Num max articoli da consegnare
        this.numMaxDaritirare = rowData.qta; //num max articoli da ritirare

        //Matricole Consegna
        this.listDettaglioRif = this.nuovoMovimento.listDettaglio.find(
          (x) => x.idArticolo == this.idArticoloRif,
        );
        if (!this.listDettaglioRif!.listMatricoleConsegna) {
          this.listDettaglioRif!.listMatricoleConsegna = [];
        }
        if (!this.listDettaglioRif!.listMatricoleRitiro) {
          this.listDettaglioRif!.listMatricoleRitiro = [];
        }

        //Carico matricole disponibili da assegnare
        this.loadMatricoleDisponibili();

        this.loadMatricoleAssegnate();
      }

      //Prop Tipologia articolo
      if (
        this.gestMatricole &&
        this.abilitaGestioneMatricole &&
        rowData.idTipoArticolo
      ) {
        const tipologia = this.listTipiArticoli.find(
          (t) => t.id == rowData.idTipoArticolo,
        );
        this.listPropsArtNewMatricola = JSON.parse(tipologia!.propJSON);
      }
    }
  }

  rowUpdated(e: any) {
    const rowData = e.data; // dati aggiornati della riga

    this.numMaxDaconsegnare = rowData.qta;
    this.numMaxDaritirare = rowData.qta;
    this.isCambio = rowData.cambio;
    if (!this.isCambio) {
      this.listDettaglioRif!.listMatricoleRitiro = [];
    }
    this.convalidaMatricole();
    this.controllaSottoScortaFunc();
  }

  /* rowChanged(e: any) {
     if (e.selectedRowsData.length > 0) {
       const row = e.selectedRowsData[0];
       this.idArticoloRif = row.idArticolo;
       console.log("Riga selezionata:", row);
     }
   }
     */

  setTipoValue = (newData: any, value: any) => {
    newData.idTipoArticolo = value;
    // Recupera il tipo articolo selezionato
    const tipo = this.listTipiArticoliFiltrati.find((t) => t.id === value);

    // Imposta automaticamente il campo 'usaMatricola'
    if (tipo) {
      newData.usaMatricola = tipo.usaMatricola;
    } else {
      newData.usaMatricola = null;
    }

    newData.idArticolo = null;
    //(<any>this).defaultSetCellValue(newData, value);
  };

  onEditCanceled(e: any) {
    this.inInserimento = false;
  }

  eliminaArticolo(e: any) {
    if (this.inInserimento) {
      return;
    }
    this.nuovoMovimento.listDettaglio.forEach((element, index) => {
      if (element.idArticolo == e.row.data.idArticolo) {
        this.nuovoMovimento.listDettaglio.splice(index, 1);
        this.listDettaglioBS.next(
          this.listDettaglioBS.value.filter(art => art.idArticolo !== element.idArticolo)
        );
      }
    });
    this.controllaSottoScortaFunc();
  }

  controllaSottoScortaFunc() {
    if (this.nuovoMovimento.listDettaglio.length == 0) {
      this.consentiSalvataggio = false;
      return;
    }
    if (this.dettParametro.valNum == 0 || this.dettParametro.valNum == 1) {
      //Nel caso di 0 non si fa proprio il controllo, nel caso di 1 si manda una notifica e basta
      this.consentiSalvataggio = true;
      return;
    }
    this.consentiSalvataggio = !this.nuovoMovimento.listDettaglio.some(
      (dettaglio) => {
        const articolo = this.listArticoliFiltro.find(
          (x) => x.id == dettaglio.idArticolo,
        );
        return articolo != undefined && articolo.giacenza < dettaglio.qta;
      },
    );
  }

  initControllaSottoscortaFunction() {
    const self = this;

    this.controllaSottoscorta = function (
      rowData: any,
      value: any,
      currentRowData: any,
    ): void {
      const idArticolo = currentRowData.idArticolo;
      //const listDettaglio = self.nuovoMovimento.listDettaglio;

      //let articolo = this.listArticoliFiltro;
      const articolo = self.listArticoliFiltro.find((x) => x.id == idArticolo);

      // console.log('articolo: ' +  JSON.stringify(this.articolo));
      //SOLO SE ARTICOLO NON è A MATRICOLO ALTRIMENTI PERMETTO DI INSERIRE MATRICOLO
      if (!self.gestMatricole || !articolo!.tipo.usaMatricola) {
        // Dai parametri se devo gestire la sottoscorta
        //	0: per non bloccante
        //	1: per avviso
        //	2: per bloccante
        if (self.dettParametro.valNum > 0) {
          //Controllo se la qta inserita è superiore alla gianceza disponibile

          if (value > articolo!.giacenza) {
            //Verifica se è bloccante (2)
            if (self.dettParametro.valNum == 2) {
              //Bloccante: disabilito il salvattagio e l'inserimento di un nuovo articolo
              self.consentiSalvataggio = false;
              self.nErrorQta += 1;
            }

            //Messaggio di avviso
            notify(
              "Attenzione! La qta inserita per l'articolo " +
              articolo!.descrizione +
              ' è superiore alla giacenza disponibile (' +
              articolo!.giacenza +
              ')',
              'warning',
              4000,
            );
          } else {
            if (self.nErrorQta > 0) {
              self.nErrorQta -= 1;
            }
            if (self.nErrorQta == 0) {
              self.consentiSalvataggio = true;
            }
          }
        }
      }
      (this as any).defaultSetCellValue(rowData, value, currentRowData);
    };
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          text: 'Aggiungi dalle consegne',
          type: 'success',
          hint: 'Aggiungi da consegne',
          disabled: !this.abilitaButtonInsertProdotti,
          onClick: this.aggiungiDaConsegneClick.bind(this),
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          text: 'Aggiungi dai previsti',
          type: 'success',
          hint: 'Aggiungi nuovo movimento',
          disabled: !this.abilitaButtonInsertProdotti,
          onClick: this.aggiungiDaPrevistiClick.bind(this),
        },
      },
    );
  }

  aggiungiDaPrevistiClick() {
    this.popUpVisiblePrevisti = true;
  }

  aggiungiDaConsegneClick() {
    this.popUpVisibleConsegne = true;
  }

  hasEditingDetail() {
    return this.gridDettaglioMov?.instance?.hasEditData();
  }

  //ASSEGNA MATRICOLE DISPONIBILI
  loadMatricoleDisponibili(id: number = 0) {
    if (this.idArticoloRif! > 0) {
      this.articoliMatService.listDisponibili(this.idArticoloRif).subscribe({
        next: (res) => {
          this.listMatricoleDisponibili = res.sort(function (a, b) {
            return a.matricola < b.matricola ? -1 : 1;
          });
          this.listMatricoleDisponibiliFiltrate = this.listMatricoleDisponibili;

          if (id > 0) {
            this.aggiungiMatricola(id); //Aggiungo matricola creata da popup alla grid
          }
        },
        error: (error) => {
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento matricole disponibili', 'warning');
          }
        },
      });
    }
  }

  aggiornaListMatricoleDisponibili() {
    if (this.listMatricoleDisponibili) {
      this.listMatricoleDisponibiliFiltrate =
        this.listMatricoleDisponibili.filter(
          (m) =>
            !this.listDettaglioRif?.listMatricoleConsegna?.some(
              (a) => a.id === m.id,
            ),
        );
    }
  }

  assegnaMatricola() {
    if (this.idArticoloMatricolaDaAssegnare) {
      this.aggiungiMatricola(this.idArticoloMatricolaDaAssegnare);
    } else {
      notificaMessaggio('Seleziona una matricola', 'warning');
    }
  }

  aggiungiMatricola(id: number) {
    if (id) {
      const matSel = this.listMatricoleDisponibiliFiltrate!.find(
        (x) => x.id == id,
      );
      if (matSel) {
        //Aggiungo matricola alla lista
        const newAssegnazione = new ArticoliMatricola();
        newAssegnazione.id = id;

        newAssegnazione.idArticolo = matSel.idArticolo;
        newAssegnazione.matricola = matSel.matricola;

        this.listDettaglioRif!.listMatricoleConsegna.push(newAssegnazione);
        // this.numConsegnati =
        //   this.listDettaglioRif!.listMatricoleConsegna?.length; //Calcolo num matricole inserite
        this.idArticoloMatricolaDaAssegnare = null;
        this.aggiornaListMatricoleDisponibili(); //Aggiorno lookup delle matricole da assegnare
        this.convalidaMatricole();
      }
    } else {
      notificaMessaggio('matricola non assegnata', 'warning');
    }
  }

  eliminaMatricolaArticolo(e: any) {
    this.listDettaglioRif!.listMatricoleConsegna.forEach((element, index) => {
      if (element.id == e.row.data.id) {
        this.listDettaglioRif!.listMatricoleConsegna.splice(index, 1); //Elimino dalla lista
        // this.numConsegnati = this.listDettaglioRif!.listMatricoleConsegna.length; //Agiorno il contatore
        this.aggiornaListMatricoleDisponibili(); //Aggiorno lookup delle matricole da assegnare
        this.convalidaMatricole();
      }
    });
  }

  //RITIRO MATRICOLE
  loadMatricoleAssegnate() {
    this.articoliMatService
      .listAssegnati(this.idArticoloRif, this.idDipendenteRif)
      .subscribe({
        next: (res) => {
          this.listMatricoleAssegnateDipendente = res.sort(function (a, b) {
            return a.matricola < b.matricola ? -1 : 1;
          });
          this.listMatricoleAssegnateDipendenteFiltrate =
            this.listMatricoleAssegnateDipendente;
        },
        error: (error) => {
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento matricole assegnate', 'warning');
          }
        },
      });
  }

  aggiornaListMatricoleAssegnate() {
    if (this.listMatricoleAssegnateDipendente) {
      this.listMatricoleAssegnateDipendenteFiltrate =
        this.listMatricoleAssegnateDipendente.filter(
          (m) =>
            !this.listDettaglioRif?.listMatricoleRitiro?.some(
              (a) => a.id === m.id,
            ),
        );
    }
  }

  assegnaRitiro() {
    if (this.idArticoloMatricolaAssegnato) {
      this.aggiungiMatricolaRitiro(this.idArticoloMatricolaAssegnato);
    } else {
      notificaMessaggio('Seleziona una matricola da ritirare', 'warning');
    }
  }

  aggiungiMatricolaRitiro(id: number) {
    if (id) {
      const matRitiro = this.listMatricoleAssegnateDipendenteFiltrate!.find(
        (x) => x.id == id,
      );
      if (matRitiro) {
        //Aggiungo matricola alla lista
        const newAssegnazione = new ArticoliMatricola();
        newAssegnazione.id = id;
        newAssegnazione.idArticolo = matRitiro.idArticolo;
        newAssegnazione.matricola = matRitiro.matricola;

        this.listDettaglioRif!.listMatricoleRitiro.push(newAssegnazione);
        this.numRitirati = this.listDettaglioRif!.listMatricoleRitiro?.length; //Calcolo num matricole inserite
        this.idArticoloMatricolaAssegnato = null;
        this.aggiornaListMatricoleAssegnate(); //Aggiorno lookup delle matricole da assegnare
        this.convalidaMatricole();
      }
    } else {
      notificaMessaggio('matricola non assegnata', 'warning');
    }
  }

  eliminaMatricolaArticoloRitiro(e: any) {
    this.listDettaglioRif!.listMatricoleRitiro.forEach((element, index) => {
      if (element.id == e.row.data.id) {
        this.listDettaglioRif!.listMatricoleRitiro.splice(index, 1); //Elimino dalla lista
        this.numRitirati = this.listDettaglioRif!.listMatricoleRitiro.length; //Agiorno il contatore
        this.aggiornaListMatricoleAssegnate(); //Aggiorno lookup delle matricole assegnate
        this.convalidaMatricole();
      }
    });
  }

  convalidaMatricole() {
    if (
      this.numMaxDaconsegnare == this.listDettaglioRif!.listMatricoleConsegna?.length &&
      (!this.isCambio || this.numMaxDaritirare == this.numRitirati)
    ) {
      this.listDettaglioRif!.matricoleConvalidate = true;
    } else {
      this.listDettaglioRif!.matricoleConvalidate = false;
    }

    this.gridDettaglioMov.instance.refresh();

    //nuovoMovimento.listDettaglio
  }

  creaMatricola() {
    //Creo nuovo codcie matricola

    // Recupero i valori della matricole
    const valori = this.listMatricoleDisponibiliFiltrate!
      .map((x) => Number(x.matricola))
      .filter((n) => !isNaN(n)); // Matricola è un campo stringa - escludo i valori non numerici

    let startMatricola = 1;

    //Recupero il max
    if (valori.length > 0) {
      const maxVal = Math.max(...valori);
      startMatricola = maxVal + 1;
    }

    // Genera matricole
    this.matricolaNew = startMatricola.toString();
  }

  //GENERA NUOVA MATRICOLA
  attivaPopUpGeneraMatricole() {
    this.popUpVisibleGeneraMatricole = true;
    this.matricolaNew = '';
    this.dataScadenzaMatricole = moment().toDate();
  }

  SalvaMatricola(e: any) {
    const resultf = e.validationGroup.validate('form-genera-matricole');
    if (!resultf.isValid) {
      return;
    }

    const result = confirm(
      '<i>Procedere con la generazione delle matricole?</i>',
      'Generazione matricole',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        this.popUpVisibleGeneraMatricole = false;
        //Salvo nuovo record nella tabella
        this.newArticoloMatricola = new ArticoliMatricola();
        this.newArticoloMatricola.idArticolo = this.idArticoloRif != undefined ? this.idArticoloRif : 0;
        this.newArticoloMatricola.matricola = this.matricolaNew != undefined ? this.matricolaNew : "";
        this.newArticoloMatricola.dataScadenza = moment(
          this.dataScadenzaMatricole,
        )
          .startOf('day')
          .utc(true)
          .toDate();
        this.newArticoloMatricola.propJson = JSON.stringify(
          this.listPropsArtNewMatricola,
        );
        this.articoliMatService.insert(this.newArticoloMatricola).subscribe({
          next: (res) => {
            if (res != null) {
              this.loadMatricoleDisponibili(res.id); //aggiorno lista delle matricole disponibili
            }
          },
          error: (error) => {
            this.popUpVisibleGeneraMatricole = false;
            ConvertError(error, 'Errore recupero articolo');
          },
        });
      }
    });
  }

  onConfermaKit() {
    this.kitArticoliService.listByIdArticolo(this.idArticoloKit!).subscribe({
      next: (res) => {
        const articoloKitInserito = this.nuovoMovimento.listDettaglio.find(
          (x) => x.idArticolo == this.idArticoloKit,
        );
        const idsArticolicComponenti = res.map((x) => x.idArticoloComponente);

        res.forEach((art) => {
          const articoloComponente = this.articoliList.find(
            (x) => x.id == art.idArticoloComponente,
          );
          if (articoloComponente == undefined) {
            return;
          }
          if (
            articoloComponente!.giacenza <
            articoloKitInserito!.qta * art.quantita &&
            this.dettParametro.valNum > 0
          ) {
            if (this.dettParametro.valNum > 1) {
              this.nuovoMovimento.listDettaglio =
                this.nuovoMovimento.listDettaglio.filter(
                  (x) => !idsArticolicComponenti.includes(x.idArticolo),
                );
            }
            notificaMessaggio(
              'Giacenza non disponibile per tutti i componenti del kit',
              'warning',
            );
            this.popupKit = false;
            return;
          }
          const index = this.nuovoMovimento.listDettaglio.findIndex(x => x.idArticolo == articoloComponente!.id);
          if (index >= 0) {
            this.nuovoMovimento.listDettaglio[index].qta += articoloKitInserito!.qta * art.quantita;
            return;
          }
          const temp = new DettaglioMovimento();
          temp.idArticolo = articoloComponente!.id;
          temp.idTipoArticolo = articoloComponente!.idTipo;
          temp.qta = articoloKitInserito!.qta * art.quantita;
          temp.cambio = this.storeS.paramLoginCorrente.cambioConsegna;
          temp.usaMatricola = this.listTipiArticoli!.find(
            (x) => x.id == articoloComponente!.idTipo,
          )!.usaMatricola;
          this.nuovoMovimento.listDettaglio.push(temp);
        });
        this.popupKit = false;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero articoli componenti kit', 'error');
        }
        this.popupKit = false;
      },
    });
  }

  onDiniegoKit() {
    this.idArticoloKit = undefined;
    this.popupKit = false;
  }

  gestisciMatricola(
    idArticolo: number,
    usaMatricola: boolean,
    quantita: number,
    idTipoArticolo: number,
  ) {
    if (idArticolo) {
      this.idArticoloRif = idArticolo;
      // notificaMessaggio("Articolo selezionato: " + this.idArticoloRif, "success");
      this.isCambio = true;

      this.abilitaGestioneMatricole = usaMatricola; // se il tipo articolo prevede la gestione delle matricole attivo le card per la gestione delle matricole in consegna e restituzione
      this.numMaxDaconsegnare = quantita; // Num max articoli da consegnare
      this.numMaxDaritirare = quantita; //num max articoli da ritirare

      //Matricole Consegna
      this.listDettaglioRif = this.nuovoMovimento.listDettaglio.find(
        (x) => x.idArticolo == this.idArticoloRif,
      );
      if (!this.listDettaglioRif!.listMatricoleConsegna) {
        this.listDettaglioRif!.listMatricoleConsegna = [];
      }
      if (!this.listDettaglioRif!.listMatricoleRitiro) {
        this.listDettaglioRif!.listMatricoleRitiro = [];
      }

      //Carico matricole disponibili da assegnare
      this.loadMatricoleDisponibili();

      this.loadMatricoleAssegnate();

      //Prop Tipologia articolo
      if (
        this.gestMatricole &&
        this.abilitaGestioneMatricole &&
        idTipoArticolo
      ) {
        const tipologia = this.listTipiArticoli.find(
          (t) => t.id == idTipoArticolo,
        );
        this.listPropsArtNewMatricola = JSON.parse(tipologia!.propJSON);
      }
    }
  }

  displayMatricola(matricola: ArticoliMatricola) {
    if (!matricola) {
      return '';
    }
    return (
      matricola.matricola +
      ' - ' +
      new Date(matricola.dataScadenza).toLocaleDateString('it-IT')
    );
  }
}

export class Change<T> {
  type: 'insert' | 'update' | 'remove';
  key: any;
  data: Partial<T>;
}
